import React from 'react'
import { Button } from '~/components/_atoms'
import { Menu, MenuItem } from '@mui/material'
import { Calendar, CalendarCheck, CalendarPlus } from 'lucide-react'

const CalendarButton = ({ event, joinUrl, isRegistered }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const createCalendarEvent = (type) => {
    const startDate = new Date(event.start_at)
    const endDate = new Date(startDate.getTime() + event.duration * 60 * 1000) // 1 hour duration
    const title = event.name
    const notIcs = type === 'google' || type === 'outlook'
    let description = event.description
    if (isRegistered && joinUrl && notIcs) {
      description += `\n\nJoin Webinar Now: ${joinUrl}`
    }
    const location = event.zoom_id ? `Zoom Meeting ID: ${event.zoom_id}` : ''

    if (type === 'google') {
      const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
        title,
      )}&details=${encodeURIComponent(
        description,
      )}&location=${encodeURIComponent(
        location,
      )}&dates=${startDate.toISOString().replace(/-|:|\.\d+/g, '')}/${endDate
        .toISOString()
        .replace(/-|:|\.\d+/g, '')}`
      window.open(googleCalendarUrl, '_blank')
    } else if (type === 'outlook') {
      const outlookCalendarUrl = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(
        title,
      )}&body=${encodeURIComponent(description)}&location=${encodeURIComponent(
        location,
      )}&startdt=${startDate.toISOString()}&enddt=${endDate.toISOString()}`
      window.open(outlookCalendarUrl, '_blank')
    } else if (type === 'ics') {
      const icsLines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `DTSTART:${startDate.toISOString().replace(/-|:|\.\d+/g, '')}`,
        `DTEND:${endDate.toISOString().replace(/-|:|\.\d+/g, '')}`,
        `SUMMARY:${title}`,
        `DESCRIPTION:${description}`,
        `LOCATION:${location}`,
      ]
      if (isRegistered && joinUrl) {
        icsLines.push(`URL: ${joinUrl}`)
      }
      icsLines.push('END:VEVENT', 'END:VCALENDAR')
      const icsContent = icsLines.join('\n')

      const blob = new Blob([icsContent], {
        type: 'text/calendar;charset=utf-8',
      })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${title}.ics`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    handleClose()
  }

  return (
    <>
      <Button
        variant="outline"
        color="secondary"
        size="sm"
        onClick={handleClick}
        className="@4xl:w-full"
        startIcon={<CalendarPlus className="h-4 w-4" />}
      >
        Add to calendar
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => createCalendarEvent('google')}>
          <Calendar className="mr-2 h-4 w-4" />
          Google Calendar
        </MenuItem>
        <MenuItem onClick={() => createCalendarEvent('outlook')}>
          <Calendar className="mr-2 h-4 w-4" />
          Outlook Calendar
        </MenuItem>
        <MenuItem onClick={() => createCalendarEvent('ics')}>
          <CalendarCheck className="mr-2 h-4 w-4" />
          Download ICS
        </MenuItem>
      </Menu>
    </>
  )
}

export default CalendarButton
